import { logisticApi } from '@/api';
import { getLanguage } from '@/lang/index';

export const QUOTATION_PACKAGE_TYPE = [];
export const QUOTATION_CALC_METHOD = [];
export const QUOTATION_FEE_ITEM = [];
export const QUOTATION_BILLING_TYPE = [];
export const QUOTATION_CHARGE_UNIT = [];

export const QUOTATION_OPTION_GROUPS = {
  QUOTATION_PACKAGE_TYPE: 'PACKAGE_TYPE',
  QUOTATION_CALC_METHOD: 'CALC_METHOD',
  QUOTATION_FEE_ITEM: 'FEE_ITEM',
  QUOTATION_BILLING_TYPE: 'BILLING_TYPE',
  QUOTATION_CHARGE_UNIT: 'CHARGE_UNIT',
};

const OPTION_LIST_MAP = {
  QUOTATION_PACKAGE_TYPE,
  QUOTATION_CALC_METHOD,
  QUOTATION_FEE_ITEM,
  QUOTATION_BILLING_TYPE,
  QUOTATION_CHARGE_UNIT,
};

let loadPromise = null;

function normalizeResponseList(res) {
  if (!res || res.failed) return [];
  return Array.isArray(res) ? res : res.content || [];
}

function normalizeOptionValue(value) {
  if (typeof value === 'string' && /^-?\d+$/.test(value)) {
    return Number(value);
  }
  return value;
}

export function normalizeQuotationOptionList(list, language = getLanguage()) {
  return (Array.isArray(list) ? list : []).map(item => ({
    label: language === 'zh' ? (item.valueName || item.valueNameEn) : (item.valueNameEn || item.valueName),
    value: normalizeOptionValue(item.valueCode),
  }));
}

function updateOptionList(optionName, list) {
  OPTION_LIST_MAP[optionName].splice(0, OPTION_LIST_MAP[optionName].length, ...list);
}

export function loadQuotationOptions({ force = false } = {}) {
  if (loadPromise && !force) return loadPromise;

  const language = getLanguage();
  let hasLoadError = false;
  loadPromise = Promise.all(
    Object.keys(QUOTATION_OPTION_GROUPS).map(optionName => (
      logisticApi.getLogisticProductTypeList({
        groupCode: QUOTATION_OPTION_GROUPS[optionName],
      }).then(res => {
        updateOptionList(optionName, normalizeQuotationOptionList(normalizeResponseList(res), language));
      }).catch(() => {
        hasLoadError = true;
        updateOptionList(optionName, []);
      })
    )),
  ).then(() => {
    if (hasLoadError) loadPromise = null;
  });

  return loadPromise;
}

export default {
  QUOTATION_PACKAGE_TYPE,
  QUOTATION_CALC_METHOD,
  QUOTATION_FEE_ITEM,
  QUOTATION_BILLING_TYPE,
  QUOTATION_CHARGE_UNIT,
  loadQuotationOptions,
};
